import { Injectable } from '@angular/core';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { SortDirection } from '@angular/material/sort';
import { IActivityStatusListResponse } from 'typings/api-activity';
import { ProgramTemplateStatusStore } from './program-template-status.store';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgramTemplateStatusService {
  constructor(private store: ProgramTemplateStatusStore, private $baseApi: DoenKidsGenericApiProvider) {}

  async fetchAll(limit: number = 10, skip: number = 0, sortField: string = 'created_at', sortDirection: SortDirection = 'desc') {
    // eslint-disable-next-line max-len
    const programTemplateStatusResponse = await firstValueFrom(this.$baseApi.genericListCall('/activity/program-template-status', limit, skip, sortField, sortDirection)) as IActivityStatusListResponse;

    this.store.set(programTemplateStatusResponse?.items ?? []);
  }
}
